/**
 * 团队试用
 * https://mastergo.com/prototyping/155677033879721?fileOpenFrom=home&page_id=M&shareId=155677033879721
 */
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useTeamEditionStore } from './teamEdition';
import { useUserStore } from './user';
import { queryTeamUserInfo } from '@/views/group/service';

interface TeamTrialState {
    /** 当前算力是否已用完 */
    isPowerExhausted: boolean;
    /** 试用开始时间 */
    trialStartTime?: string;
    /** 试用结束时间 */
    trialEndTime?: string;
    /** 剩余算力 */
    remainingPower: number;
    /** 总试用算力 */
    totalTrialPower: number;
}

// 试用期到时，按钮文案
export const TRIAL_EXPIRED_BUTTON_TEXT = '试用已到期，开通正式版';
// 算力用完，按钮文案
export const POWER_EXHAUSTED_BUTTON_TEXT = '算力已用完，开通正式版';

export const useTeamTrialStore = defineStore('teamTrial', () => {
    const state = ref<TeamTrialState>({
        isPowerExhausted: !true,
        trialStartTime: undefined,
        trialEndTime: undefined,
        remainingPower: 0,
        totalTrialPower: 0
    });

    /** 当前是否为试用版 */
    const isTrialVersion = computed(() => {
        const userStore = useUserStore();
        return userStore.sources.periodType === 2;
    });

    /** 当前是否为团队试用版本 */
    const isTeamTrial = computed(() => {
        const teamEditionStore = useTeamEditionStore();
        return teamEditionStore.isTeamVersion && isTrialVersion.value;
    });

    /** 当前试用期是否已过期 */
    const isTrialExpired = computed(() => {
        const userStore = useUserStore();
        const teamEditionStore = useTeamEditionStore();
        const userType = teamEditionStore.userType;
        // 如果是团队版本，使用lastExpireMemberList，如果是个人版本，使用lastExpireMemberTeamList
        let isExitExpired = userType === 'team' ? userStore.sources.lastExpireMemberList.length > 0 : userStore.sources.lastExpireMemberTeamList.length > 0;
        return isTrialVersion.value && isExitExpired;
    });

    /** 当前算力是否已用完 */
    const isPowerExhausted = computed(() => {
        const userStore = useUserStore();
        const totalPower = userStore.sources.dailyPower + userStore.sources.foreverPower;
        return isTeamTrial.value && totalPower <= 0;
    });


    /** 生图时的前置判断 */
    const isAbleToGenerate = computed<boolean>(() => {
        const teamEditionStore = useTeamEditionStore();
        if (isTeamTrial.value && teamEditionStore.userType === 'team') {
            if (isTrialExpired.value || isPowerExhausted.value) {
                return false;
            }
        }
        return true;
    });

    // 获取试用版本团队人数
    const getTrialTeamMemberCount = async () => {
        const { data } = await queryTeamUserInfo({
            pageNo: 1,
            pageSize: 100
        });

        return {
            all: data.headCount,
            occupied: data.joinCount,
            preparHeadCount: data.preparHeadCount
        }
    };

    return {
        state,
        isTeamTrial,
        isTrialExpired,
        isPowerExhausted,
        isAbleToGenerate,
        isTrialVersion,
        getTrialTeamMemberCount
    };
}); 